import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImagesModule } from 'lib/images/images.module.js';
import { DividerModule } from '../divider/index.js';
import { AppFlexModule } from '../flex/index.js';
import { IconModule } from '../icons/index.js';
import { CardComponent } from './card.component.js';
import { ButtonModule } from '../buttons/index.js';
import { TypographyModule } from 'lib/typography/index.js';
import { GraphsModule } from '../graphs/index.js';
import { LinkModule } from '../link/link.module.js';
import { TagModule } from '../tag/index.js';
import { FocusedCardComponent } from './focused-card.component.js';
import { TooltipModule } from '../tooltip/tooltip.module.js';

@NgModule({
	declarations: [CardComponent, FocusedCardComponent],
	exports: [CardComponent, FocusedCardComponent],
	imports: [
		TagModule,
		CommonModule,
		RouterModule,
		IconModule,
		AppFlexModule,
		ImagesModule,
		DividerModule,
		ButtonModule,
		TypographyModule,
		GraphsModule,
		LinkModule,
		TooltipModule
	]
})
export class CardModule {}
